








































import { defineComponent, PropType } from "@vue/composition-api";
import { ApiResponse } from "@/api/types";
import RankDiff from "../../Atom/RankDiff/index.vue";
import { Location } from "vue-router";

export interface Props {
  companyRank: Partial<ApiResponse.CompanyRank> & {
    title: string;
    loading?: boolean;
    to?: Location;
  };
}

export default defineComponent({
  name: "CompanyRank",
  components: {
    RankDiff
  },
  props: {
    companyRank: {
      type: Object as PropType<Props["companyRank"]>,
      required: true
    }
  }
});
